// get zoom level from place (location)
export function getZoomLevel(place) {
  const zoom =  place.zoom_level || place.type.zoom_level;
  return Number(zoom).toFixed(1)
}